<form class="flex flex-column" (validate)="save()" novalidate validation-es>
  <ms-common-person-form name="personForm" [(ngModel)]="person"></ms-common-person-form>

  <hr>

  <ms-common-patient-form name="patientModel" [(ngModel)]="patient"></ms-common-patient-form>

  <hr>

  <div class="align-self-end">
    <button pButton type="submit" [label]="screen.actions.save" [loading]="loading" icon="far fa-save" iconPos="left"
      class="p-button-success p-button-outlined"></button>
  </div>
</form>